import React from "react";
// import { Breadcrumbs } from "./components/navigation/Breadcrumbs/Breadcrumbs";
// import { Hero } from "./components/sections/Hero";
// import { Centered } from "./components/layout/Centered";
// import { Container } from "./components/layout/Container";
// import { LogoCloud } from "./components/sections/LogoCloud";
// import { FeatureDescription } from "./components/sections/Features";
// import { ClientQuote } from "./components/sections/ClientQuote";
// import { SectionHeadline } from "./components/sections/SectionHeadline";
// import { CodeEmbed } from "./components/sections/CodeEmbed";
// import { LinkList } from "./components/navigation/LinkList";
// import { PagePreviewList } from "./components/sections/PagePreviewList/PagePreviewList";
// import { RichText } from "./components/typography/RichText";
// import { Newsletter } from "./components/sections/Newsletter";
// import { CallToAction } from "./components/sections/CallToActionSection";
// import { ImageSection } from "./components/sections/ImageSection";
// import { TableOfContent } from "./components/sections/TableOfContent";
// import { Navbar } from "./components/navigation/Navbar";
// import { TagCloud } from "./components/sections/TagCloud";
// import { ZoneContainer } from "./components/sections/ZoneContainer";
// import { Video } from "./components/sections/Video/Video";
// import { FeatureGrid } from "./components/sections/Features/FeatureGrid";
// import { List } from "./components/sections/List/List";
// import { InfoBox } from "./components/sections/InfoBox/InfoBox";
// import { Table } from "./components/dataDisplay/Table/Table";
// import { FaqSection } from "./components/sections/Faq/FaqSection";
// import { ImageText } from "./components/sections/ImageText/ImageText";
// import { Contact } from "./components/forms/Contact/Contact";

// console.log('-------', PagePreviewList);

let componentMap: any = {
  // // elements
  // ComponentElementsRichText: RichText,
  // // layout
  // centered: Centered,
  // default: ({ children, ...rest }: { children: React.ReactNode }) => (
  //   <Container {...rest}>{children}</Container>
  // ),
  // none: ({
  //   children,
  //   className,
  // }: {
  //   children: React.ReactNode;
  //   className?: string;
  // }) => <div className={className || ""}>{children}</div>,
  // // navigation
  // ComponentNavigationLinkList: LinkList,
  // ComponentNavigationNavbar: Navbar,
  // ComponentNavigationBreadcrumbs: Breadcrumbs,
  // // sections
  // ComponentSectionsHero: Hero,
  // ComponentSectionsInfoBox: InfoBox,
  // ComponentSectionsLogoCloud: LogoCloud,
  // ComponentSectionsFeatureDescription: FeatureDescription,
  // ComponentSectionsClientQuote: ClientQuote,
  // ComponentSectionsSectionHeadline: SectionHeadline,
  // ComponentSectionsCodeEmbed: CodeEmbed,
  // ComponentSectionsPagePreviewList: PagePreviewList,
  // ComponentSectionsNlSub: Newsletter,
  // ComponentSectionsCallToAction: CallToAction,
  // ComponentSectionsImage: ImageSection,
  // ComponentSectionsTable: Table,
  // ComponentSectionsTableOfContent: TableOfContent,
  // ComponentSectionsTagCloud: TagCloud,
  // ComponentSectionsZoneContainer: ZoneContainer,
  // ComponentSectionsVideo: Video,
  // ComponentSectionsFeatureGrid: FeatureGrid,
  // ComponentSectionsList: List,
  // ComponentSectionsFaq: FaqSection,
  // ComponentSectionsContact: Contact,
  // ComponentSectionsImageText: ImageText,
};

export function extendComponentMap(map: any) {
  componentMap = { ...componentMap, ...map };
}

export function getComponentMap() {
  return componentMap;
}
